import KeyAccountLayout from "@/layouts/KeyAccountLayout.vue";

import type { RouteRecordRaw } from "vue-router";

const expressistConnexionRoutes: RouteRecordRaw[] = [
  {
    path: "/transporters/expressist-connexions",
    name: "expressistConnexions",
    component: () =>
      import("@/views/restricted/transporters/expressist-connexions/ExpressistConnexionListView.vue"),
    meta: {
      layout: KeyAccountLayout,
      menuSelected: "transporters",
      requiresAuth: true,
      permissions: ["KEY_ACCOUNT_TRANSPORTER_READ_PERMISSION"],
    },
  },
  {
    path: "/transporters/expressist-connexions/create",
    name: "expressistConnexionCreate",
    component: () =>
      import("@/views/restricted/transporters/expressist-connexions/ExpressistConnexionFormView.vue"),
    meta: {
      layout: KeyAccountLayout,
      menuSelected: "transporters",
      requiresAuth: true,
      permissions: ["KEY_ACCOUNT_TRANSPORTER_CREATE_PERMISSION"],
    },
  },
  {
    path: "/transporters/expressist-connexions/:connexionId",
    name: "expressistConnexionDetail",
    component: () =>
      import("@/views/restricted/transporters/expressist-connexions/ExpressistConnexionDetailView.vue"),
    meta: {
      layout: KeyAccountLayout,
      menuSelected: "transporters",
      requiresAuth: true,
      permissions: ["KEY_ACCOUNT_TRANSPORTER_READ_PERMISSION"],
    },
  },
  {
    path: "/transporters/expressist-connexions/:connexionId/edit",
    name: "expressistConnexionUpdate",
    component: () =>
      import("@/views/restricted/transporters/expressist-connexions/ExpressistConnexionFormView.vue"),
    meta: {
      layout: KeyAccountLayout,
      menuSelected: "transporters",
      requiresAuth: true,
      permissions: ["KEY_ACCOUNT_TRANSPORTER_UPDATE_PERMISSION"],
    },
  },
];

export default expressistConnexionRoutes;
